import React, { Component } from 'react'
import { Card } from 'react-bootstrap'
import { ConfirmPopUp } from '../../utils/dialogue/ConfirmPopUp'
import { servicesCategoryMap } from './servicesConstants'
import { withRouter } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import findKey from 'lodash/findKey'

class FilteredServicesColumn extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showPopUp: false,
        }
        this.onClosePopUp = this.onClosePopUp.bind(this)
        this.myRef = null
        
    }
    onCardError=(e)=>{
        e.target.onerror = null
        e.target.src = `/images/global/personalizer/image-not-available-640.jpg`
    }

    onCardClick(selectedservice) {
        let { service, selectedGuestDetails = false } = this.props
        if (!isEmpty(selectedGuestDetails) && selectedGuestDetails.PassengerDetail.Age < 18 && false) {
            if (
                selectedGuestDetails.PassengerDetail.Age <= 12 ||
                (service.serviceGroup !== 'zspaervicesforteens' &&
                    service.serviceGroup !== 'zspaforteens')
            ) {
                this.setState({ showPopUp: true })
                return
            }
        }
        this.props.onCardClick(selectedservice)
        this.props.history.push('/reserve')
    }

    onClosePopUp() {
        this.setState({ showPopUp: false })
    }

    render() {
        let { service, selectedGuestDetails, ShipboardCurrencyCode } = this.props

        let WarningText = this.state.showPopUp
            ? 'Due to age restrictions ' +
            service.treatmentDesc +
            ' is not available for ' +
            selectedGuestDetails.PassengerDetail.Name.FirstName +
            ' ' +
            selectedGuestDetails.PassengerDetail.Name.LastName
            : ''
        let category =
            findKey(servicesCategoryMap, (item) => item === service.serviceGroup) ||
            service.serviceGroup
        //TO DO
        let imageUrl = `${process.env.imageUrl}/${service.treatmentId}.jpg`
        return (
            <div className="filtered-col-container">
                <Card data-test-id="card-three-up" className="filtered-col filtered-card-container">
                    <Card.Img
                        onClick={this.onCardClick.bind(this, service)}
                        className="filtered-col-img"
                        data-test-id="column-image"
                        variant="top"
                        src={imageUrl}
                        onError={this.onCardError}
                    />
                    <div className="col-card-header">
                        <h3
                            onClick={this.onCardClick.bind(this, service)}
                            tabindex="0"
                            className="filtered-card-title font-size-p10"
                            data-test-id="column-services-title">
                            {service.treatmentDesc}
                        </h3>
                        <p
                            className="filtered-card-category-text  font-size-p2 gotham-xn-medium"
                            data-test-id="column-services-category">
                            {category}
                        </p>
                    </div>
                    <Card.Body>
                        <Card.Text>
                            <div className="font-size-p2 gotham-book">
                                {service.shortDescription}
                            </div>
                        </Card.Text>
                    </Card.Body>
                    <Card.Footer className="column-card-footer">
                        <div className="col-price text-center">
                            <span className="font-size-p4 gotham-xn-medium"> from </span>
                            <span>
                                <sup className="font-size-p2 gotham-xn-medium dollar-price">{`${ShipboardCurrencyCode === 'USD' ? '$' : 'AU$'} `}</sup>
                                <span
                                    style={{ fontSize: '32px' }}
                                    className="gotham-xn-medium"
                                    data-test-id="col-price">
                                    {service.price}
                                </span>
                            </span>
                        </div>
                        {service.serviceGroup !== 'zspaervicesforteens' && service.serviceGroup !== 'zspaforteens' &&

                            <div className='age-warning-text row no-gutters  red'>
                                <div data-test-id='spa-age-col-warning' className='col-xs-12 age-warn-text'>This spa reservation is only available for guests over 18 years of age.</div>
                            </div>
                        }
                        <div>
                            <button
                                onClick={this.onCardClick.bind(this, service)}
                                className="button font-size-p5 gotham-xn-book primary-btn font-size-m2"
                                aria-label={`Reserve Now - ${service.treatmentDesc} from  $ ${service.price}`}>
                                Reserve Now
                            </button>
                        </div>
                    </Card.Footer>
                </Card>
                <ConfirmPopUp
                    title="Information"
                    contentText={WarningText}
                    isCancel={false}
                    onConfirm={this.onClosePopUp}
                    onClose={this.onClosePopUp}
                    show={this.state.showPopUp}
                />
            </div>
        )
    }
}
export default withRouter(FilteredServicesColumn)
